
import { defineComponent, onMounted, ref } from 'vue';

import ModTimelineIndicator from './timeline/mod-timeline-indicators.vue';
import ModTimelineFrames from './timeline/mod-timeline-frames.vue';
import ModTimelineContent from './timeline/mod-timeline-content.vue';
import ModContentTimelineLoader from './mod-content-timeline-loader.vue';

import ModFrameTarget from './add-ons/mod-frame-target.vue';
import ModStopwatch from './add-ons/mod-stopwatch.vue';

import ModHeader from './mod-header.vue';

import { modDataComposition } from '../services';

// Component Composition 
function componentComposition () {
	const loaderTime = ref(2000);
	const loader = ref(true);

	onMounted(() => {
		setTimeout(() => {
			loader.value = false;
		}, loaderTime.value)
	});

	return { loader }
}

export default defineComponent({
	components: {
		ModTimelineIndicator,
		ModTimelineFrames,
		ModTimelineContent,
		ModContentTimelineLoader,
		ModFrameTarget,
		ModStopwatch,
		ModHeader
	},
	setup() {
		return { ...modDataComposition(), ...componentComposition() }
	},
})
